module.exports = [
  'deployed_dev',
  'integration',
  'production',
  'staging',
]
